/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyDocumentApprovalViewerViewModel } from "../types/AssociatedCompanyDocumentApprovalViewerViewModel.ts";
import { associatedCompanyDocumentApprovalDocumentViewModelSchema } from "./associatedCompanyDocumentApprovalDocumentViewModelSchema.ts";

export const associatedCompanyDocumentApprovalViewerViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula."),
  ),
  personId: z.optional(z.number().int().describe("ID da pessoa (aluno).")),
  code: z.string().describe("Código da pessoa.").nullish(),
  name: z.string().describe("Nome completo do aluno.").nullish(),
  email: z.string().describe("E-mail do aluno.").nullish(),
  enrollmentStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status da matrícula. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
      ),
  ),
  enrollmentStatusText: z
    .string()
    .describe("Descrição do status da matrícula (pt-BR).")
    .nullish(),
  documentationStatus: z
    .number()
    .int()
    .describe(
      "Status geral da documentação pessoal da matrícula (exposto pelo legado). Opcional. Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
    )
    .nullish(),
  associatedCompanyDocumentationStatus: z
    .number()
    .int()
    .describe(
      "Status geral da documentação da empresa conveniada na matrícula. Opcional. Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
    )
    .nullish(),
  classStudentText: z.string().describe("Descrição da turma.").nullish(),
  associatedCompanyName: z
    .string()
    .describe("Nome da empresa conveniada do aluno; vazio quando não há.")
    .nullish(),
  isIriCourse: z.optional(
    z.boolean().describe("Indica se a turma pertence a curso IRI."),
  ),
  hasPostGradDocument: z.optional(
    z.boolean().describe("Indica se o curso exige diploma de pós-graduação."),
  ),
  hasOtherDocuments: z.optional(
    z.boolean().describe("Indica se o aluno possui documentos avulsos."),
  ),
  hasDocumentScanned: z.optional(
    z
      .boolean()
      .describe(
        "Indica se algum documento legível por OCR possui leitura persistida.",
      ),
  ),
  allowChangeStatus: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o status da matrícula pode ser alterado para Aprovado a partir da tela.",
      ),
  ),
  updateEnrollmentStatus: z.optional(
    z
      .boolean()
      .describe(
        "Estado inicial do checkbox de atualização do status da matrícula (baseado na documentação pessoal, regra do legado).",
      ),
  ),
  documentsOfCourse: z
    .array(
      z.lazy(() => associatedCompanyDocumentApprovalDocumentViewModelSchema),
    )
    .describe(
      "Documentos de empresa associada do curso, na ordem de exibição do legado.",
    )
    .nullish(),
}) as unknown as ToZod<AssociatedCompanyDocumentApprovalViewerViewModel>;
